/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useMemo } from 'react';

import axios from 'axios';
import { LogoTinyTransicao } from 'images';
import { RootContext } from 'pages/leads/components/leads-provider';
// import { API_URLS } from 'pages/leads/constants';
import { useAsyncFn } from 'react-use';
import { URL_FULL_LEAD, URL_LEAD_INFO } from 'utils/api-urls';

import { Button } from '@olist/design-system';
import { ArrowRightFill } from '@olist/design-system-icons';

import { Banner, LogoTiny } from './banner-tiny.styles';

const BannerTiny = () => {
  const { leadIdCookie, leadProfileCookie } = useContext(RootContext);

  // const [{ value: fullLeadsResponse }, fetchFullLead] = useAsyncFn(async () => {
  //   return axios.get(URL_FULL_LEAD(leadProfileCookie?.email));
  // }, [leadProfileCookie]);

  const [{ loading, value: leadInfo }, fetchLeadInfo] = useAsyncFn(async () => {
    return axios.get(URL_LEAD_INFO(leadIdCookie));
  }, [leadIdCookie]);

  useEffect(() => {
    fetchLeadInfo();
    // fetchFullLead();
  }, [fetchLeadInfo]);

  const urlTiny = useMemo(() => {
    const lead: any = leadInfo?.data;
    if (lead) {
      return `https://tiny.com.br/olist-tiny?parceiro=oliststore_self&cnpj=${lead.document_number}&celular=${lead.phone}&email=${lead.email}&name=${lead.name}`;
    }
    return ``;
  }, [leadInfo]);

  if (loading) {
    return null;
  }

  return (
    <Banner>
      <div>
        <LogoTiny src={LogoTinyTransicao} />
      </div>
      <p>
        Aproveite a condição especial que liberamos para você e contrate Tiny com um super desconto
        na mensalidade.
      </p>
      <div>
        <Button variation="secondary" iconRight={ArrowRightFill} href={urlTiny}>
          clique aqui para saber mais.
        </Button>
      </div>
    </Banner>
  );
};

export { BannerTiny };
